import { render, staticRenderFns } from "./setting-pricePlan.vue?vue&type=template&id=29a1f7f2&scoped=true&"
import script from "./setting-pricePlan.vue?vue&type=script&lang=js&"
export * from "./setting-pricePlan.vue?vue&type=script&lang=js&"
import style0 from "./setting-pricePlan.vue?vue&type=style&index=0&id=29a1f7f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a1f7f2",
  null
  
)

export default component.exports